// extracted by mini-css-extract-plugin
export default {"cardContainer":"card_cardContainer__U8S03","cardTitle":"card_cardTitle__91-8y","cardH2":"card_cardH2__niJaw","pStyle":"card_pStyle__TYVpY"};